(function () {

  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {

    /* ======================================================
       HTML
       ====================================================== */

    const app = document.getElementById('dfl-postcode-app');
    const overlay = document.getElementById('dfl-postcode-overlay');
    const start = document.getElementById('dfl-postcode-start');
    const success = document.getElementById('dfl-postcode-success');
    const request = document.getElementById('dfl-postcode-request');
    const outside = document.getElementById('dfl-postcode-outside');

    const form = document.getElementById('dfl-postcode-form');
    const input = document.getElementById('dfl-postcode-input');
    const error = document.getElementById('dfl-postcode-error');

    const skip = document.getElementById('dfl-postcode-skip');
    const changeButton = document.getElementById('dfl-postcode-change');
    const currentPostcode = document.getElementById('dfl-postcode-current');

    if (!app) {
      console.error(
        'DFL PLZ: #dfl-postcode-app wurde nicht gefunden. Prüfe die Theme-Vorschau.'
      );
      return;
    }

    if (
      !overlay ||
      !start ||
      !success ||
      !request ||
      !outside ||
      !form ||
      !input ||
      !error
    ) {
      console.error('DFL PLZ: Benötigte HTML-Elemente fehlen.');
      return;
    }


    /* ======================================================
       TESTMODUS

       Normal:
       deinfutterlieferant-shop.de

       Test:
       ?dfltest=1

       Bei bestehender Preview-URL:
       &dfltest=1
       ====================================================== */

    const urlParams = new URLSearchParams(window.location.search);
    const TEST_MODE = urlParams.get('dfltest') === '1';


    /* ======================================================
       REGULÄRES LIEFERGEBIET
       ====================================================== */

    const DELIVERY_POSTCODES = new Set([
      '25482',
      '25355',
      '25485',
      '25364',
      '25335',
      '25474',
      '25494',
      '25373',
      '25436',
      '25469',
      '25489',
      '25492',
      '25491',
      '25488',
      '25336',
      '25365',
      '25337',
      '25495',
      '25421',
      '25497',
      '25451',
      '25462',
      '22869',
      '25370',
      '25371',
      '25499',
      '22880',
      '22559',
      '22457',
      '25377',
      '25368',
      '25358',
      '22589'
    ]);


    /* ======================================================
       LIEFERUNG AUF ANFRAGE
       ====================================================== */

    const REQUEST_POSTCODES = new Set([
    ]);


    /* ======================================================
       AFFILIATE-PARTNER
       ====================================================== */

    const PARTNERS = {

      horse: {
        name: 'Pferdefutter.de',
        url: ''
      },

      cat: {
        name: 'ZooRoyal',
        url: ''
      },

      rider: {
        name: 'EQUIVA',
        url: 'https://www.awin1.com/cread.php?awinmid=13870&awinaffid=3054657&clickref=plz_modal_reitbekleidung&ued=https%3A%2F%2Fwww.equiva.com%2Freiter'
      }

    };


    /* ======================================================
       SPEICHER
       ====================================================== */

    const STORAGE_DAYS = 30;

    const STORAGE_KEY = 'dfl_delivery_postcode';
    const SESSION_KEY = 'dfl_delivery_postcode_session';
    const SKIP_KEY = 'dfl_postcode_skipped';


    /* ======================================================
       ANSICHTEN
       ====================================================== */

    function hideAllScreens() {
      start.hidden = true;
      success.hidden = true;
      request.hidden = true;
      outside.hidden = true;
    }


    function openModal(screen) {

      hideAllScreens();

      screen.hidden = false;
      app.hidden = false;
      overlay.hidden = false;

      overlay.style.setProperty(
        'display',
        'flex',
        'important'
      );

      document.body.classList.add(
        'dfl-postcode-open'
      );
    }


    function closeModal() {

      overlay.hidden = true;

      overlay.style.setProperty(
        'display',
        'none',
        'important'
      );

      document.body.classList.remove(
        'dfl-postcode-open'
      );
    }


    function showStart() {

      error.hidden = true;
      input.value = '';

      openModal(start);

      window.setTimeout(function () {
        input.focus();
      }, 100);
    }


    /* ======================================================
       PLZ-ANZEIGE
       ====================================================== */

    function updatePostcodeButton(postcode) {

      if (!changeButton || !currentPostcode) {
        return;
      }

      currentPostcode.textContent = postcode;
      changeButton.hidden = false;
    }


    /* ======================================================
       SHOPIFY PRIVACY / CONSENT
       ====================================================== */

    function getPrivacyApi() {

      if (
        window.Shopify &&
        window.Shopify.customerPrivacy
      ) {
        return window.Shopify.customerPrivacy;
      }

      return null;
    }


    function preferencesAllowed() {

      try {

        const privacy = getPrivacyApi();

        if (
          privacy &&
          typeof privacy.currentVisitorConsent === 'function'
        ) {

          const consent =
            privacy.currentVisitorConsent();

          return consent.preferences === 'yes';
        }

      } catch (e) {
        console.warn(
          'DFL PLZ: Preference-Consent konnte nicht gelesen werden.'
        );
      }

      return false;
    }


    function privacyBannerNeedsDecision() {

      try {

        const privacy = getPrivacyApi();

        if (
          privacy &&
          typeof privacy.shouldShowBanner === 'function'
        ) {
          return privacy.shouldShowBanner();
        }

      } catch (e) {
        console.warn(
          'DFL PLZ: Cookie-Banner-Status konnte nicht gelesen werden.'
        );
      }

      return null;
    }


    /* ======================================================
       PLZ SPEICHERN
       ====================================================== */

    function savePostcode(postcode, status) {

      updatePostcodeButton(postcode);

      if (TEST_MODE) {
        return;
      }

      const data = {

        postcode: postcode,

        status: status,

        expires:
          Date.now() +
          STORAGE_DAYS *
          24 *
          60 *
          60 *
          1000
      };


      try {

        if (preferencesAllowed()) {

          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(data)
          );

          sessionStorage.removeItem(
            SESSION_KEY
          );

        } else {

          sessionStorage.setItem(
            SESSION_KEY,
            JSON.stringify(data)
          );
        }

      } catch (e) {

        console.warn(
          'DFL PLZ: PLZ konnte nicht gespeichert werden.'
        );
      }
    }


    /* ======================================================
       SPEICHER LESEN
       ====================================================== */

    function parseStoredData(raw) {

      if (!raw) {
        return null;
      }

      try {

        const data = JSON.parse(raw);

        if (!data.postcode || !data.expires) {
          return null;
        }

        if (Date.now() > data.expires) {
          return null;
        }

        return data;

      } catch (e) {
        return null;
      }
    }


    function getSavedPostcode() {

      if (TEST_MODE) {
        return null;
      }


      if (preferencesAllowed()) {

        try {

          const permanent =
            parseStoredData(
              localStorage.getItem(STORAGE_KEY)
            );

          if (permanent) {
            return permanent;
          }

          localStorage.removeItem(
            STORAGE_KEY
          );

        } catch (e) {
        }

      }


      try {

        const session =
          parseStoredData(
            sessionStorage.getItem(SESSION_KEY)
          );

        if (session) {
          return session;
        }

        sessionStorage.removeItem(
          SESSION_KEY
        );

      } catch (e) {
      }


      return null;
    }


    /* ======================================================
       PLZ EINORDNEN
       ====================================================== */

    function classifyPostcode(postcode) {

      if (DELIVERY_POSTCODES.has(postcode)) {
        return 'delivery';
      }

      if (REQUEST_POSTCODES.has(postcode)) {
        return 'request';
      }

      return 'outside';
    }


    /* ======================================================
       ERGEBNIS
       ====================================================== */

    function showResult(postcode) {

      const status =
        classifyPostcode(postcode);

      savePostcode(
        postcode,
        status
      );


      if (status === 'delivery') {

        openModal(success);
        return;
      }


      if (status === 'request') {

        openModal(request);
        return;
      }


      openModal(outside);
    }


    /* ======================================================
       AFFILIATE-PARTNER
       ====================================================== */

    function setupPartner(type) {

      const partner = PARTNERS[type];

      const link =
        document.getElementById(
          'dfl-partner-' + type
        );

      const name =
        document.getElementById(
          'dfl-partner-' + type + '-name'
        );


      if (!partner || !link || !name) {
        return;
      }


      name.textContent =
        partner.name || 'Online-Partner';


      if (partner.url) {

        link.href = partner.url;

        link.target = '_blank';
        link.rel = 'sponsored noopener';

        link.classList.remove(
          'dfl-postcode__partner--disabled'
        );

        link.removeAttribute(
          'aria-disabled'
        );

        return;
      }


      /*
       * Noch nicht freigeschaltet.
       */

      link.href = '#';

      link.removeAttribute('target');

      link.classList.add(
        'dfl-postcode__partner--disabled'
      );

      link.setAttribute(
        'aria-disabled',
        'true'
      );


      link.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
        }
      );
    }


    setupPartner('horse');
    setupPartner('cat');
    setupPartner('rider');


    /* ======================================================
       PLZ-FORMULAR
       ====================================================== */

    form.addEventListener(
      'submit',
      function (event) {

        event.preventDefault();

        const postcode =
          input.value
            .replace(/\D/g, '')
            .trim();


        if (!/^\d{5}$/.test(postcode)) {

          error.hidden = false;

          input.focus();

          return;
        }


        error.hidden = true;

        showResult(postcode);
      }
    );


    input.addEventListener(
      'input',
      function () {

        this.value =
          this.value
            .replace(/\D/g, '')
            .slice(0, 5);

        error.hidden = true;
      }
    );


    /* ======================================================
       SHOP TROTZDEM ANSEHEN
       ====================================================== */

    if (skip) {

      skip.addEventListener(
        'click',
        function () {

          if (!TEST_MODE) {

            try {

              sessionStorage.setItem(
                SKIP_KEY,
                '1'
              );

            } catch (e) {
            }
          }

          closeModal();
        }
      );
    }


    /* ======================================================
       PLZ ÄNDERN
       ====================================================== */

    if (changeButton) {

      changeButton.addEventListener(
        'click',
        function () {
          showStart();
        }
      );
    }


    /* ======================================================
       JETZT EINKAUFEN / SCHLIESSEN
       ====================================================== */

    document.addEventListener(
      'click',
      function (event) {

        const closeButton =
          event.target.closest(
            '[data-dfl-close]'
          );

        if (!closeButton) {
          return;
        }

        event.preventDefault();

        closeModal();
      }
    );


    /* ESC */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          !overlay.hidden
        ) {
          closeModal();
        }
      }
    );


    /* ======================================================
       PLZ-ABFRAGE STARTEN
       ====================================================== */

    function startPostcodeCheck() {


      if (TEST_MODE) {

        try {

          localStorage.removeItem(
            STORAGE_KEY
          );

          sessionStorage.removeItem(
            SESSION_KEY
          );

          sessionStorage.removeItem(
            SKIP_KEY
          );

        } catch (e) {
        }


        app.hidden = false;

        showStart();

        console.log(
          'DFL PLZ: Testmodus aktiv.'
        );

        return;
      }


      const saved =
        getSavedPostcode();


      if (saved) {

        app.hidden = false;

        overlay.hidden = true;

        overlay.style.setProperty(
          'display',
          'none',
          'important'
        );

        updatePostcodeButton(
          saved.postcode
        );

        return;
      }


      let skipped = false;

      try {

        skipped =
          sessionStorage.getItem(
            SKIP_KEY
          ) === '1';

      } catch (e) {
      }


      app.hidden = false;


      if (skipped) {

        overlay.hidden = true;

        overlay.style.setProperty(
          'display',
          'none',
          'important'
        );

        return;
      }


      showStart();
    }


    /* ======================================================
       COOKIE-BANNER ZUERST
       ====================================================== */

    let postcodeStarted = false;


    function startPostcodeOnce() {

      if (postcodeStarted) {
        return;
      }

      postcodeStarted = true;

      startPostcodeCheck();
    }


    function waitForCookieDecision() {

      let apiAttempts = 0;


      function waitForApi() {

        apiAttempts++;

        const privacy =
          getPrivacyApi();


        if (
          privacy &&
          typeof privacy.shouldShowBanner === 'function'
        ) {

          waitUntilBannerFinished();

          return;
        }


        if (apiAttempts < 20) {

          window.setTimeout(
            waitForApi,
            250
          );

          return;
        }


        startPostcodeOnce();
      }


      function waitUntilBannerFinished() {

        const needsDecision =
          privacyBannerNeedsDecision();


        if (needsDecision === false) {

          startPostcodeOnce();

          return;
        }


        if (needsDecision === true) {

          window.setTimeout(
            waitUntilBannerFinished,
            300
          );

          return;
        }


        window.setTimeout(
          waitUntilBannerFinished,
          300
        );
      }


      document.addEventListener(
        'visitorConsentCollected',
        function () {

          window.setTimeout(
            startPostcodeOnce,
            100
          );

        }
      );


      waitForApi();
    }


    waitForCookieDecision();

  });

})();